<div class="custom-page-header">
  <div class="flex items-center gap-2">
    <span class="cursor-pointer" (click)="closeEvent ? closeEvent.emit() : null">
      <i class="fa fa-chevron-left text-white text-lg"></i>
    </span>
    <label class="title"> {{ !assessment ? 'Create' : 'Edit' }} Assessment </label>
  </div>
</div>

<div class="custom-layout">
  <div class="custom-layout-content">
    <div class="flex flex-col items-center justify-center">
      <div class="w-full" style="max-width: 900px">
        <microsec-form-builder
          #fb
          [isPage]="true"
          [fields]="fields"
          [shouldShowActionButtons]="false"
          [shouldSubmitOnEnter]="false"
          [hasInfoFields]="false" />
      </div>
    </div>
  </div>

  @if (!!form && !!form.form) {
    <div class="custom-layout-action-buttons">
      <div class="w-full" style="max-width: 1500px">
        <p-divider />
        <div class="flex flex-wrap items-center justify-end gap-2 mt-8">
          <div class="flex items-center gap-2">
            @if (activeStep > 0) {
              <p-button
                type="button"
                severity="primary"
                label="Back"
                icon="fa fa-angle-left"
                iconPos="left"
                [disabled]="!!form.isLoading"
                (onClick)="onStepChange(-1)" />
            }
            @if (
              (!!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC) && activeStep < 2) ||
              (!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC) && activeStep < 1)
            ) {
              <p-button
                type="button"
                severity="primary"
                label="Next"
                icon="fa fa-angle-right"
                iconPos="right"
                [disabled]="!!form.isLoading || !isCurrentStepValid"
                (onClick)="onStepChange(1)" />
            }
            @if (
              (!!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC) && activeStep === 2) ||
              (!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC) && activeStep === 1)
            ) {
              <p-button
                type="button"
                severity="success"
                label="Complete"
                icon="fa fa-angle-right"
                iconPos="right"
                [disabled]="
                  !!form.isLoading ||
                  !form.form.valid ||
                  (!!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC) && (!selectedDeviceIds || !selectedDeviceIds.length))
                "
                (onClick)="onSubmit()" />
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #stepsTemplate>
  <div class="m-2">
    <microsec-custom-steps [steps]="steps" [activeStep]="activeStep" />
  </div>
</ng-template>

<ng-template #titleTemplate>
  <div class="flex flex-col items-center gap-2">
    <label class="text-lg font-bold">{{ steps[activeStep] ? steps[activeStep].label : '' }}</label>
    <label class="text-grey">Provide the following information to create an assessment.</label>
  </div>
</ng-template>

<ng-template #configurationTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <microsec-card [isBordered]="true" styleClass="rounded-lg mt-2">
        <div class="flex flex-col p-2">
          <label class="font-bold text-2xl">Assessment Configuration</label>
          <div class="flex flex-col gap-4 mt-6">
            <label class="font-bold text-lg">Assessment Type <microsec-asterisk /></label>
            <p-select
              styleClass="w-80"
              [options]="assessmentTypeOptions"
              [formControlName]="FORM_PARAMS.ASSESSMENT_TYPE_ID"
              placeholder="Select assessment type"
              optionLabel="label"
              optionValue="value"
              appendTo="body" />
            <ng-container
              [ngTemplateOutlet]="errorTemplate"
              [ngTemplateOutletContext]="{
                formName: FORM_PARAMS.ASSESSMENT_TYPE_ID,
                formLabel: 'Assessment Type'
              }">
            </ng-container>
          </div>
        </div>
      </microsec-card>
    </ng-container>
  }
</ng-template>

<ng-template #devicesTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <microsec-card [isBordered]="true" styleClass="rounded-lg mt-2">
        <div class="flex flex-col p-2">
          <div class="flex justify-between items-center gap-2">
            <label class="font-bold text-2xl">Device Specific Assessment</label>
            <p-toggleswitch [formControlName]="FORM_PARAMS.IS_DEVICE_SPECIFIC" />
          </div>
          <label class="text-grey mt-2">Devices will be evaluated individually for a more comprehensive assessment.</label>
          @if (!!form.getControlValue(FORM_PARAMS.IS_DEVICE_SPECIFIC)) {
            <div class="flex flex-col gap-2 mt-6" style="width: calc(900px - 3.75rem)">
              <app-shared-device-table
                #deviceTable
                [cachedSelectedDevices]="cachedSelectedDevices"
                [checkNonCompliance]="checkNonCompliance"
                [(selectedDeviceIds)]="selectedDeviceIds"
                (selectedDevicesChange)="selectedDevices = $event"
                isMulticast="false" />
            </div>
          }
        </div>
      </microsec-card>
    </ng-container>
  }
</ng-template>

<ng-template #prefillingTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <microsec-card [isBordered]="true" styleClass="rounded-lg mt-2">
        <div class="flex flex-col p-2">
          <div class="flex justify-between items-center gap-2">
            <div class="flex items-center gap-2">
              <label class="font-bold text-2xl">Assessment Prefilling</label>
              <img src="/assets/images/prefilling-icon.svg" alt="prefilling-icon" />
            </div>
            <p-toggleswitch [formControlName]="FORM_PARAMS.USE_PREFILLING" />
          </div>
          <label class="text-grey mt-2">Intelligently populates responses based on advanced heuristic and available information.</label>
          @if (!!form.getControlValue(FORM_PARAMS.USE_PREFILLING)) {
            <div class="flex flex-col gap-2 mt-12">
              <div class="relative h-12 mx-8">
                <span class="absolute mx-auto left-0 right-0" style="width: calc(100% - 2rem)">
                  <p-slider
                    class="w-full"
                    [(ngModel)]="selectedPrefillingLevel"
                    [ngModelOptions]="{ standalone: true }"
                    [step]="1"
                    [min]="1"
                    [max]="3"
                    styleClass="prefilling-level-slider" />
                </span>
                @if (selectedPrefillingLevel !== 1) {
                  <label class="absolute cursor-pointer" style="top: -0.4rem; left: 0.95rem" (click)="selectedPrefillingLevel = 1"> • </label>
                }
                @if (selectedPrefillingLevel !== 2) {
                  <label class="absolute cursor-pointer" style="top: -0.4rem; left: 50%" (click)="selectedPrefillingLevel = 2"> • </label>
                }
                @if (selectedPrefillingLevel !== 3) {
                  <label class="absolute cursor-pointer" style="top: -0.4rem; right: 1.5rem" (click)="selectedPrefillingLevel = 3"> • </label>
                }
                <label
                  class="absolute cursor-pointer text-center"
                  style="top: 1rem; left: 0.5rem"
                  [ngClass]="{ 'text-highlight font-bold': selectedPrefillingLevel === 1 }"
                  (click)="selectedPrefillingLevel = 1">
                  Low
                </label>
                <label
                  class="absolute cursor-pointer text-center"
                  style="top: 1rem; left: calc(50% - 1.75rem)"
                  [ngClass]="{ 'text-highlight font-bold': selectedPrefillingLevel === 2 }"
                  (click)="selectedPrefillingLevel = 2">
                  Medium<br />(Default)
                </label>
                <label
                  class="absolute cursor-pointer"
                  style="top: 1rem; right: 0"
                  [ngClass]="{ 'text-highlight font-bold': selectedPrefillingLevel === 3 }"
                  (click)="selectedPrefillingLevel = 3">
                  High
                </label>
              </div>
              <microsec-card styleClass="bg-custom-grey rounded-lg mt-6">
                <div class="flex flex-col gap-2">
                  @switch (selectedPrefillingLevel) {
                    @case (1) {
                      <label class="font-bold">Low Assessment Prefilling</label>
                      <label>
                        Low prefilling prioritizes accuracy over speed, carefully prefilling responses with a high confidence score. Although fewer
                        questions will be prefilled, this approach ensures accuracy and reliability.
                      </label>
                    }
                    @case (2) {
                      <label class="font-bold">Medium Assessment Prefilling</label>
                      <label>
                        Medium prefilling is the default and recommended setting for assessment prefilling. This mode prefills a broad range of
                        questions while maintaining a high confidence score.
                      </label>
                    }
                    @case (3) {
                      <label class="font-bold">High Assessment Prefilling</label>
                      <label>
                        High prefilling prioritizes speed over accuracy, prefilling more responses with a lower confidence score. Consider this option
                        for expediting your cybersecurity assessment, especially when time is a critical factor.
                      </label>
                    }
                  }
                </div>
              </microsec-card>
              <div class="card-background prefill-info py-6 flex justify-evenly mt-4">
                <div class="flex flex-col justify-center">
                  <label class="text-2xl text-gradient-blue"
                    >{{
                      ((prefillingInfo?.confidence_scores?.[PREFILLING_SCORE_LEVEL[selectedPrefillingLevel]]?.total_prefillable_questions || 0) /
                        (prefillingInfo?.total_questions || 0)) *
                        100 | number: '1.0-2'
                    }}%</label
                  >
                  <label>% Questions that can be prefilled</label>
                </div>
                <p-divider layout="vertical" class="-mx-4"></p-divider>
                <div class="flex flex-col justify-center">
                  <label class="text-2xl text-gradient-blue"
                    >{{ prefillingInfo?.confidence_scores?.[PREFILLING_SCORE_LEVEL[selectedPrefillingLevel]]?.total_prefillable_questions || 0 }}/{{
                      prefillingInfo?.total_questions || 0
                    }}</label
                  >
                  <label>Questions that can be prefilled</label>
                </div>
              </div>
              <div class="flex justify-center items-center gap-2 mt-6">
                <label class="text-grey cursor-pointer hover:underline" (click)="showBreakdown = !showBreakdown">
                  {{ !showBreakdown ? 'Show' : 'Hide' }} Breakdown By Device
                </label>
                <i [class]="!showBreakdown ? 'pi pi-chevron-right text-grey' : 'pi pi-chevron-down text-grey'"> </i>
              </div>
              @if (!!showBreakdown) {
                <div class="card-background prefill-info flex justify-center items-center gap-2 mt-6 p-6">
                  <microsec-card [isTableCard]="true">
                    <microsec-common-table
                      #dt
                      [style]="{ width: 'calc(900px - 3.75rem)' }"
                      [cols]="cols"
                      [values]="selectedDevices || []"
                      [dataKey]="'id'"
                      [cellTemplate]="selectedDevicesCellTemplate"
                      itemName="Device" />
                  </microsec-card>
                </div>
              }
            </div>
          }
        </div>
      </microsec-card>
    </ng-container>
  }
</ng-template>

<ng-template #generalTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <microsec-card [isBordered]="true" styleClass="rounded-lg">
        <div class="flex flex-col p-4">
          <label class="font-bold text-2xl">General Information</label>
          <label class="text-grey mt-4">Provide a name, description, scheduled date and assignee for this assessment.</label>
          <div class="flex flex-col gap-2 mt-6">
            <label class="font-bold text-lg">Name <microsec-asterisk /></label>
            <input type="text" [maxlength]="50" pInputText [formControlName]="FORM_PARAMS.NAME" />
            <ng-container
              [ngTemplateOutlet]="errorTemplate"
              [ngTemplateOutletContext]="{
                formName: FORM_PARAMS.NAME,
                formLabel: 'Name'
              }">
            </ng-container>
          </div>
          <div class="flex flex-col gap-2 mt-6">
            <label class="font-bold text-lg">Description</label>
            <microsec-custom-markdown-editor [textareaFormGroup]="form.form" [textareaFormControlName]="FORM_PARAMS.DESCRIPTION" />
          </div>
          <div class="flex flex-col gap-2 mt-6">
            <label class="font-bold text-lg">Scheduled Date</label>
            <p-datepicker
              styleClass="w-80"
              placeholder="Select a date"
              appendTo="body"
              [readonlyInput]="true"
              [formControlName]="FORM_PARAMS.SCHEDULED"
              [minDate]="scheduledMinDate"
              [showButtonBar]="true"
              [dateFormat]="PRIMENG_CALENDAR_DATE"
              [hourFormat]="'24'"
              [showTime]="true"
              [showSeconds]="false" />
          </div>
          <!-- <div class="flex flex-col gap-2 mt-6">
            <label class="font-bold text-lg">Assignee</label>
            <p-select
              styleClass="w-80"
              [options]="assigneeOptions"
              [formControlName]="FORM_PARAMS.ASSIGNEE_USER_ID"
              placeholder="Select assignee"
              optionLabel="label"
              optionValue="value"
              appendTo="body" />
          </div> -->
        </div>
      </microsec-card>
    </ng-container>
  }
</ng-template>

<ng-template let-formName="formName" let-formLabel="formLabel" #errorTemplate>
  @if (!!form && !!form.form) {
    <label
      class="text-error"
      *ngIf="!!form.form.get(formName)?.errors && !!form.form.get(formName)?.errors?.['incorrect']"
      [innerHTML]="form.form.get(formName)?.errors?.['message']">
    </label>
    <label
      class="text-error"
      *ngIf="!!form.form.get(formName)?.errors?.['required'] && !!form.form.get(formName)?.touched && !!form.form.get(formName)?.dirty">
      {{ formLabel }} is required
    </label>
  }
</ng-template>

<ng-template let-col="col" let-rowData="rowData" #selectedDevicesCellTemplate>
  <ng-container [ngSwitch]="col.field">
    <!-- Type -->
    <ng-container *ngSwitchCase="'type'">
      <microsec-truncate-text>
        {{ (rowData[col.field] | constant: 'detected-device-type') || '-' }}
      </microsec-truncate-text>
    </ng-container>
    <!-- Zones -->
    <ng-container *ngSwitchCase="'zones'">
      <div
        class="flex items-center w-max"
        [pTooltip]="!!rowData[col.field]?.length ? $any(rowData[col.field] | arrayMapPipe: 'label' : true) : ''"
        tooltipPosition="top"
        appendTo="body">
        <ng-container *ngFor="let zone of rowData[col.field] || []; let i = index; let firstZone = first; let lastZone = last">
          <div *ngIf="!!firstZone" class="custom-chip" [style]="{ background: util.hexToRgba(zone.color), color: zone.color }">
            {{ zone.label }}
          </div>
          <div *ngIf="!firstZone && !!lastZone" class="ml-1">+{{ i }}</div>
        </ng-container>
      </div>
    </ng-container>
    <!-- Prefillable Questions -->
    <ng-container *ngSwitchCase="'prefilling'">
      <span
        >{{ rowData?.prefilling?.[selectedPrefillingLevel]?.total_prefillable_questions || 0 }}/{{
          rowData?.prefilling?.[selectedPrefillingLevel]?.total_questions || 0
        }}
        ({{
          ((rowData?.prefilling?.[selectedPrefillingLevel]?.total_prefillable_questions || 0) /
            (rowData?.prefilling?.[selectedPrefillingLevel]?.total_questions || 0)) *
            100 | number: '1.0-2'
        }}%)</span
      >
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ rowData[col.field] || '-' }}
      </div>
    </ng-container>
  </ng-container>
</ng-template>
